import LoginSuccessPage from './login-success-page';

export default LoginSuccessPage;
